export const breadcrumConstants = {
  UPDATE_NAVBAR_TITLE: "UPDATE_NAVBAR_TITLE",
};
